import { render } from "./YouthModeOverlay.vue?vue&type=template&id=5d2859f3&scoped=true"
import script from "./YouthModeOverlay.vue?vue&type=script&lang=js"
export * from "./YouthModeOverlay.vue?vue&type=script&lang=js"

import "./YouthModeOverlay.vue?vue&type=style&index=0&id=5d2859f3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d2859f3"]])

export default __exports__